import { useState } from 'react';
import { theme } from '../../theme';
import { useIsMobile } from '../../hooks/useMediaQuery';

const inputSt = {
  width: '100%',
  padding: '8px 10px',
  background: theme.colors.background,
  border: `1px solid ${theme.colors.border}`,
  borderRadius: '6px',
  color: theme.colors.text,
  fontSize: '0.88rem',
  boxSizing: 'border-box',
  outline: 'none',
};

export default function TransferModal({ agents, flows, onTransfer, onTransferToFlow, onClose }) {
  const [tab, setTab] = useState('agent');
  const [selectedFlowId, setSelectedFlowId] = useState(flows?.[0]?.id?.toString() || '');
  const isMobile = useIsMobile();

  const tabSt = (active) => ({
    flex: 1,
    padding: '8px',
    background: active ? theme.colors.primary : 'transparent',
    color: active ? theme.colors.background : theme.colors.textMuted,
    border: 'none',
    cursor: 'pointer',
    fontWeight: active ? 700 : 400,
    fontSize: '0.85rem',
    borderRadius: '6px',
    transition: 'all 0.15s',
  });

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200,
      padding: isMobile ? '1rem' : 0,
    }}>
      <div style={{
        background: theme.colors.surface, borderRadius: '12px',
        border: `1px solid ${theme.colors.border}`, padding: '1.5rem',
        minWidth: isMobile ? 0 : '340px',
        width: isMobile ? '100%' : undefined, maxWidth: isMobile ? '340px' : undefined,
        boxSizing: 'border-box',
      }}>
        <h3 style={{ color: theme.colors.primary, marginBottom: '1rem', fontSize: '1rem' }}>
          Transferir conversación
        </h3>

        {/* Tabs */}
        <div style={{ display: 'flex', gap: '4px', background: theme.colors.background, borderRadius: '8px', padding: '4px', marginBottom: '1rem' }}>
          <button style={tabSt(tab === 'agent')} onClick={() => setTab('agent')}>A Agente</button>
          <button style={tabSt(tab === 'flow')} onClick={() => setTab('flow')}>A Flujo</button>
        </div>

        {/* Agent tab */}
        {tab === 'agent' && (
          <>
            {agents.length === 0 ? (
              <p style={{ color: theme.colors.textMuted, fontSize: '0.88rem' }}>No hay agentes online disponibles.</p>
            ) : (
              agents.map((a) => (
                <button key={a.id} onClick={() => onTransfer(a.id)} style={{
                  display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
                  background: theme.colors.background, border: `1px solid ${theme.colors.border}`,
                  borderRadius: '8px', padding: '10px 14px', cursor: 'pointer',
                  color: theme.colors.text, marginBottom: '8px', fontSize: '0.9rem',
                }}>
                  <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#4ade80', display: 'inline-block' }} />
                  {a.username}
                </button>
              ))
            )}
          </>
        )}

        {/* Flow tab */}
        {tab === 'flow' && (
          <>
            {flows.length === 0 ? (
              <p style={{ color: theme.colors.textMuted, fontSize: '0.88rem' }}>No hay flujos disponibles.</p>
            ) : (
              <>
                <div style={{ marginBottom: '1rem' }}>
                  <label style={{ display: 'block', color: theme.colors.textMuted, fontSize: '0.8rem', marginBottom: '6px' }}>
                    Seleccionar flujo
                  </label>
                  <select
                    value={selectedFlowId}
                    onChange={(e) => setSelectedFlowId(e.target.value)}
                    style={{ ...inputSt, cursor: 'pointer' }}
                  >
                    <option value="">— Seleccionar —</option>
                    {flows.map((f) => (
                      <option key={f.id} value={f.id}>{f.name}</option>
                    ))}
                  </select>
                </div>
                <button
                  onClick={() => { if (selectedFlowId) onTransferToFlow(selectedFlowId); }}
                  disabled={!selectedFlowId}
                  style={{
                    width: '100%', padding: '9px', background: selectedFlowId ? theme.colors.primary : theme.colors.border,
                    color: theme.colors.background, border: 'none', borderRadius: '7px',
                    fontWeight: 700, fontSize: '0.88rem', cursor: selectedFlowId ? 'pointer' : 'not-allowed',
                  }}
                >
                  Transferir al flujo
                </button>
              </>
            )}
          </>
        )}

        <button onClick={onClose} style={{
          marginTop: '0.75rem', background: 'transparent', border: 'none',
          color: theme.colors.textMuted, cursor: 'pointer', fontSize: '0.85rem', width: '100%',
        }}>
          Cancelar
        </button>
      </div>
    </div>
  );
}
